<template>
  <v-dialog v-model="value" :max-width="580" :persistent="true">
    <v-card>
      <v-card-title class="headline d-flex justify-space-between w-100">
        <div>
          <slot name="title"></slot>
        </div>
      </v-card-title>
      <v-card-text>
        <slot name="text"></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="buttons"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationModalView',
  props: {
    value: Boolean,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  methods: {
    onCancel() {
      this.$emit('onCancel');
    },
    onOk() {
      this.$emit('onOk');
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  font-family: 'Helvetica', sans-serif !important;
  color: $color-base;
}

.content {
  padding: 24px;
  background-color: white;
}
</style>
